const getLinkProps = (props = []) =>
  props
    .map(({ propertiesToDisplay, enableLink }) => enableLink && propertiesToDisplay)
    .flat()
    .filter(Boolean);

export default getLinkProps;
